import { createFileRoute } from "@tanstack/react-router";
import { useSite } from "@/components/site/site-data";
import { PageHeader } from "@/components/site/PageHeader";

export const Route = createFileRoute("/gala")({
  head: () => ({
    meta: [
      { title: "Gala Specialiștilor din Energie — ediția a V-a" },
      {
        name: "description",
        content:
          "Gala Specialiștilor din Energie, ediția a V-a: „Să punem OAMENII din ENERGIE în LUMINĂ!” — 6 octombrie 2026, Le Château, București.",
      },
      { property: "og:title", content: "Gala Specialiștilor din Energie — ediția a V-a" },
      {
        property: "og:description",
        content: "Să punem OAMENII din ENERGIE în LUMINĂ! Momente din edițiile anterioare.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: Gala,
});

function VideoGrid({
  items,
}: {
  items: { id: string; title: string; youtube_id: string }[];
}) {
  return (
    <div className="mt-8 grid gap-8 md:grid-cols-2">
      {items.map((v) => (
        <figure key={v.id}>
          <div className="aspect-video overflow-hidden rounded-xl bg-muted shadow-lift">
            <iframe
              src={`https://www.youtube.com/embed/${v.youtube_id}`}
              title={v.title}
              loading="lazy"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="h-full w-full"
            />
          </div>
          <figcaption className="mt-3 font-display font-bold">{v.title}</figcaption>
        </figure>
      ))}
    </div>
  );
}

function Gala() {
  const { blocks, videos } = useSite();
  const gala = videos.filter((v) => v.category === "gala");
  const aniversar = videos.filter((v) => v.category === "aniversar");

  return (
    <main>
      <PageHeader
        title="Gala Specialiștilor din Energie"
        subtitle="„Să punem OAMENII din ENERGIE în LUMINĂ!” — ediția a V-a"
      />
      <section className="mx-auto max-w-6xl px-6 py-16">
        <p className="max-w-6xl text-lg leading-relaxed whitespace-pre-line text-foreground/90">
          {blocks["gala_intro"]?.body}
        </p>
        <VideoGrid items={gala} />

        {aniversar.length > 0 && (
          <>
            <h2 className="mt-20 text-3xl font-bold">Video aniversar InvesTenergy</h2>
            <VideoGrid items={aniversar} />
          </>
        )}
      </section>
    </main>
  );
}
